export default __webpack_public_path__ + "static/media/failed.c30d7947.svg";